var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyFlight = function SvgHappyFlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#647A97",
    d: "M13.547 1.133a1.665 1.665 0 1 1 1.276 3.078l-2.897 1.08a.33.33 0 0 0-.182.163l-2.5 5a.66.66 0 0 1-.3.299l-1.806.903a.668.668 0 0 1-.922-.831L7.52 7.346a.16.16 0 0 0-.04-.178.17.17 0 0 0-.178-.035L3.557 8.632a.67.67 0 0 1-.718-.147L.342 5.988a.665.665 0 0 1 .21-1.085l1.737-.744a.68.68 0 0 1 .561.016l1.584.792a.34.34 0 0 0 .282.008l8.826-3.842zM5.651.323a.68.68 0 0 1 .511 0L9.687 1.78a.167.167 0 0 1 0 .307L6.92 3.29a.33.33 0 0 1-.26 0l-2.6-1.076a.666.666 0 0 1 0-1.231z"
  })));
};
export default SvgHappyFlight;